// Central site configuration. Edit these values to update the site globally.
export const site = {
  name: 'Spectranox',
  tagline: 'Engineering the full spectrum of software, intelligence & security.',
  description:
    'Spectranox is a full-stack technology studio. We build software, apps, websites, AI, IoT, drones and cyber security solutions — and offer ready-to-use SaaS tools on flexible subscriptions.',
  /* Intentionally empty. The origin is whatever the site is being served
     from; anything that needs an absolute URL calls siteOrigin() below. A
     constant here would mean every canonical, og:url and JSON-LD @id kept
     naming one domain no matter where the bundle was uploaded. */
  url: '',
  email: 'hello@spectranox.com',
  phone: '+91 91213 51765',
  location: 'Hyderabad, India · Serving clients worldwide',
  city: 'Hyderabad',
  region: 'Telangana',
  /* Countries with delivered work, mirroring the flags in the About marquee. */
  areaServed: ['India', 'Poland', 'Latvia', 'United Kingdom', 'United States',
    'Canada', 'Germany', 'Netherlands', 'Australia', 'United Arab Emirates', 'Singapore'],
  /* Named for search engines, in the same priority order as the nav. */
  offerings: [
    'Website Development', 'App Development', 'Software Development',
    'Cyber Security', 'AI & Automation', 'IoT Development', 'UI/UX Design',
    'Digital Marketing', 'Business Consulting', 'Social Media Management',
    'Drone Development',
  ],
  currency: '$', // change to '₹', '€', etc.
  founded: 2020,
  social: {
    twitter: 'https://twitter.com/',
    linkedin: 'https://linkedin.com/',
    github: 'https://github.com/',
    instagram: 'https://instagram.com/',
  },
  nav: [
    { label: 'Home', to: '/' },
    { label: 'Services', to: '/services' },
    { label: 'Portfolio', to: '/portfolio' },
    { label: 'About', to: '/about' },
    { label: 'Contact', to: '/contact' },
  ],
  stats: [
    { value: '15+', label: 'Service domains' },
    { value: '4', label: 'SaaS products' },
    { value: '24/7', label: 'Support & hosting' },
    { value: '100%', label: 'Client-focused' },
  ],
}

/* The one blue a section heading is allowed to highlight with.

   Five headings were each picking their own — #1c8eff on "at Spectranox",
   #1d4ed8 on "Real Results", #005699 on two more, and a three-stop gradient
   on "love Spectranox" — so scrolling the homepage walked through four
   different blues in four consecutive sections. This is the value the primary
   buttons already use, which is what makes it the brand's blue rather than
   just one of them. */
export const TITLE_BLUE = '#1d4ed8'

/* The origin this page is actually being served from. Empty string during the
   prerender pass, where callers fall back to a root-relative path. */
export const siteOrigin = () =>
  (typeof window !== 'undefined' && window.location?.origin) || ''
